import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

export const formatSeconds = (
  t: TTranslator<TLocalesKeys>,
  s: number,
  int?: boolean
): string =>
  t(
    'time.contracted.hours',
    (s / 3600).toLocaleString(undefined, {
      maximumFractionDigits: int ? 0 : 2,
    })
  );

export const formatPercents = (p: number): string =>
  `${p.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;

export const formatMoney = (m: number, cur: string): string =>
  `${m.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${cur}`;
